var _defs, _rect, _rect2, _rect3, _rect4, _ellipse, _circle, _circle2, _circle3, _path, _rect5, _line, _line2, _line3, _circle4, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObservationTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "obsGrad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f89f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "obsGrad2",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ecb488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fccc9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "obsGrad3",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f89f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f17067"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 45,
    width: 270,
    height: 195,
    rx: 8,
    fill: "url(#obsGrad1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 55,
    width: 250,
    height: 175,
    rx: 4,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 240,
    width: 70,
    height: 30,
    rx: 3,
    fill: "url(#obsGrad2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 265,
    width: 150,
    height: 15,
    rx: 5,
    fill: "url(#obsGrad3)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175,
    cy: 140,
    rx: 70,
    ry: 45,
    fill: "none",
    stroke: "url(#obsGrad1)",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 140,
    r: 25,
    fill: "url(#obsGrad1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 140,
    r: 12,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 140,
    r: 5,
    fill: "#414042"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105,90 Q175,60 245,90",
    fill: "none",
    stroke: "url(#obsGrad3)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 80,
    width: 50,
    height: 65,
    rx: 4,
    fill: "#fff",
    stroke: "url(#obsGrad1)",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 95,
    x2: 270,
    y2: 95,
    stroke: "url(#obsGrad2)",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 108,
    x2: 265,
    y2: 108,
    stroke: "url(#obsGrad2)",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 121,
    x2: 260,
    y2: 121,
    stroke: "url(#obsGrad2)",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 135,
    r: 15,
    fill: "none",
    stroke: "url(#obsGrad3)",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 275,
    y1: 145,
    x2: 290,
    y2: 160,
    stroke: "url(#obsGrad3)",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObservationTrack);
export default __webpack_public_path__ + "static/media/ObservationTrack.72476750be433314b7c1d36784f5f9f5.svg";
export { ForwardRef as ReactComponent };